import { API_URL } from '../../config'
import store from '../store'

export default {
  namespaced: true,
  actions: {
    async getReporte({}, payload) {
      // Usar el endpoint /generar para todos los reportes autodealer
      const endpoint = '/autodealer-reportes/generar'

      console.groupCollapsed('[reportesAutodealer/getReporte] Solicitud saliente')
      console.log('endpoint:', `${API_URL}${endpoint}`)
      console.log('payload:', payload)
      console.log('token presente:', Boolean(store.state.token))
      console.groupEnd()

      try {
        const response = await fetch(`${API_URL}${endpoint}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'Application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(payload)
        })

        console.log('[reportesAutodealer/getReporte] HTTP status:', response.status, 'ok:', response.ok)

        const result = await response.json()

        console.groupCollapsed('[reportesAutodealer/getReporte] Respuesta cruda del backend')
        console.log(result)
        console.groupEnd()

        // Normalizar la respuesta para que sea consistente
        if (result.success && result.data) {
          return {
            exito: 1,
            data: result.data,
            message: result.message || 'Reporte generado correctamente.'
          }
        }

        // Si hay un error, retornar estructura consistente
        return {
          exito: 0,
          data: null,
          message: result.message || 'Error al generar el reporte.'
        }
      } catch (error) {
        console.error('[reportesAutodealer/getReporte] Error ejecutando fetch del reporte:', error)
        throw error
      }
    },
    async getReporte0kmUsadosVendidos({}, payload) {
      
      const endpoint = '/autodealer-reportes/unidades-usados-vendidas-gdb-dycar-rada'
      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      const result = await response.json()
      
      // Normalizar la respuesta para que sea consistente
      if (result.success && result.data) {
        return {
          exito: 1,
          data: result.data,
          message: result.message || 'Reporte generado correctamente.'
        }
      }
      
      // Si hay un error, retornar estructura consistente
      return {
        exito: 0,
        data: null,
        message: result.message || 'Error al generar el reporte.'
      }
    }
  }
}
